import { Children, ReactNode } from 'react';
import { EmblaViewportRefType } from 'embla-carousel-react';
import EmblaStyle from '../../styles/EmblaCarousel.module.css';

type Props = {
  children: ReactNode;
  selectedIndex: number;
  emblaThumbsRef: EmblaViewportRefType;
  onClick: (index: number) => void;
};

function ThumbsButton({
  children,
  selectedIndex,
  emblaThumbsRef,
  onClick,
}: Props) {
  const thumbsArray = Children.toArray(children);
  const thumbs = thumbsArray.map((thumb, idx) => (
    <button
      key={`thumbs-${idx}`}
      onClick={() => onClick(idx)}
      className={`${EmblaStyle.emblaThumbsSlide} ${
        idx === selectedIndex && EmblaStyle.emblaThumbSelected
      }`}
    >
      {thumb}
    </button>
  ));

  return (
    <div className={EmblaStyle.thumbs}>
      <div className={EmblaStyle.thumbsViewport} ref={emblaThumbsRef}>
        <div className={EmblaStyle.thumbsContainer}>{thumbs}</div>
      </div>
    </div>
  );
}

export default ThumbsButton;
